import { combineReducers } from "redux"

/*------------------------------------------------------------------
[General]
-------------------------------------------------------------------*/
const general_state = {
    name : 'Andika Chamberlin'
}

const general = (state = general_state, action) => {
    return state
}
/*------------------------------------------------------------------
[End General]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Token]
-------------------------------------------------------------------*/
const token_state = {
    data : ''
}

const token = (state = token_state, action) => {

    if(action.type === 'SET_TOKEN'){
        return{
            ...state,
            [action.inputType] : action.inputValue
        }
    }
    return state
}
/*------------------------------------------------------------------
[End Token]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Token]
-------------------------------------------------------------------*/
const auth_state = {
    data : 'login'
}

const auth = (state = auth_state, action) => {

    if(action.type === 'SET_AUTH'){
        return{
            ...state,
            [action.inputType] : action.inputValue
        }
    }
    return state
}
/*------------------------------------------------------------------
[End Token]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[User]
-------------------------------------------------------------------*/
const user_state = {
    data : ''
}

const user = (state = user_state, action) => {

    if(action.type === 'SET_USER'){
        return{
            ...state,
            [action.inputType] : action.inputValue
        }
    }
    return state
}
/*------------------------------------------------------------------
[End User]
-------------------------------------------------------------------*/

const reducer = combineReducers({
    general,
    token,
    auth,
    user
});

export default reducer